import * as React from 'react';
import { Navigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { TextField, BaseTextFieldProps } from '@mui/material';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import '../../../hmilib/hmiglobal';

import * as ExperionScript from '../../../hmilib/hooks/ExperionScript';

interface iTopMenu {}

const TopMenu = (props: iTopMenu) => {
    const [refmenu, setRefmenu] = React.useState<string>();

    let VisibelMenu = false;

    React.useEffect(() => {
        loadmenu();

        return () => {
            ofloadmenu();
        };
    }, []);

    let modifyMenu = function (e: any) {
        const isNotTopMenu = e.target.className != `experion_topmenu_nav_main`;

        if (isNotTopMenu) {
            closeMenu();
        }
    };

    let closeMenu = function () {
        if (VisibelMenu) {
            VisibelMenu = false;
            let arrvis = document.getElementsByClassName('experion_topmenu_vis');

            for (let vis = 0; vis < arrvis.length; vis++) {
                arrvis[vis].classList.remove('experion_topmenu_vis');
            }
        }
    };

    let blurwindow = function () {
        closeMenu();
    };

    let loadmenu = function () {
        ConverterMenu(ExperionScript.menuexperionxml);
        ConverterToolBar(ExperionScript.menuexperionxml);

        window.addEventListener('click', modifyMenu);

        window.addEventListener('blur', blurwindow);
    };

    let ConverterToolBar = function (TextConverter: string) {
        let MainToolBar, ElementToolBar;
        let xmlDoc, parser;
        let html, TempStr;
        let NumberElementToolBar;

        html = '';

        parser = new DOMParser();
        xmlDoc = parser.parseFromString(TextConverter, 'text/xml');
        MainToolBar = xmlDoc.getElementsByTagName('Toolbar')[0]?.children;
        if (MainToolBar != null) {
            for (NumberElementToolBar = 0; NumberElementToolBar < MainToolBar.length; NumberElementToolBar++) {
                ElementToolBar = MainToolBar[NumberElementToolBar];

                if (ElementToolBar.nodeName == 'Item') {
                    TempStr = ElementToolBar.getAttribute('CommandID') || '';
                    ExperionScript.SetNameCommand(ElementToolBar.getAttribute('Caption') || '');
                    html =
                        html +
                        ExperionScript.FindCommand(TempStr, false) +
                        ExperionScript.FindImage(TempStr, false) +
                        '</a>';
                }
                if (ElementToolBar.nodeName == 'Separator') {
                    html =
                        html +
                        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAWCAYAAAAM2IbtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAiSURBVChTY6AxaGlq+Q8CUC4YMEFprGBUEggGQpL+gIEBANrgBqJjqWIgAAAAAElFTkSuQmCC"></img>';
                }
            }
        }

        let ToolBarDiv = document.getElementsByClassName('experion_topmenu_toolbar')[0];
        if (ToolBarDiv != null) {
            ToolBarDiv.innerHTML = html;
        }

        MenuNav();
    };

    let MenuNav = function () {
        var ulback = document.getElementById('ulback');
        var ulforward = document.getElementById('ulforward');
        var html = ' ';
        if (ulback != null) {
            for (var i = 0; i < ExperionScript.IndexArrayPage - 1; i++) {
                html += '<li><a onclick="GoPage(' + i + ')">';
                html +=
                    '<img src="data: image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZSURBVEhL7cExAQAAAMKg9U9tCU8gAICDGghWAAHPSM1fAAAAAElFTkSuQmCC" alt="Select Output" align="left" height="18px">';
                html += ExperionScript.arrayPage[i] + '</a></li>';
            }
            if (html) {
                let ulback = document.getElementById('ulback');
                if (ulback != null) {
                    ulback.innerHTML = html;
                }
            }
        }
        html = ' ';
        if (ulforward != null) {
            for (let j = ExperionScript.IndexArrayPage; j < ExperionScript.arrayPage.length; j++) {
                html += '<li><a onclick="GoPage(' + j + ')">';
                html +=
                    '<img src="data: image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZSURBVEhL7cExAQAAAMKg9U9tCU8gAICDGghWAAHPSM1fAAAAAElFTkSuQmCC" alt="Select Output" align="left" height="18px">';
                html += ExperionScript.arrayPage[j] + '</a></li>';
            }

            if (html) {
                let ulforward = document.getElementById('ulforward');
                if (ulforward != null) {
                    ulforward.innerHTML = html;
                }
            }
        }
    };
    let ConverterMenu = function (Text: string) {
        let MainMenu, Elements, ElementMenu;
        let xmlDoc, parser;
        let menumaindiv = document.createElement('div');

        let menumainul = document.createElement('ul');
        menumainul.setAttribute('class', 'experion_topmenu_nav');
        menumaindiv.appendChild(menumainul);

        parser = new DOMParser();
        xmlDoc = parser.parseFromString(Text, 'text/xml');
        MainMenu = xmlDoc.getElementsByTagName('StationMenu')[0]?.children;
        if (MainMenu != null) {
            for (let NumberElement = 0; NumberElement < MainMenu.length; NumberElement++) {
                ElementMenu = MainMenu[NumberElement];
                if (ElementMenu.nodeName === 'Menu') {
                    Elements = ElementMenu.childNodes;

                    var menumainli = document.createElement('li');
                    menumainli.setAttribute('class', 'experion_topmenu_nav_main');
                    var TempHTML =
                        '<a class="experion_topmenu_nav_main">' + ElementMenu.getAttribute('Caption') + '</a>';
                    TempHTML = TempHTML + ConverChilds(Elements);
                    menumainli.innerHTML = TempHTML;
                    let mainmenumainli = menumainli.querySelector('.experion_topmenu_nav_main') as HTMLElement;
                    if (mainmenumainli != null) {
                        mainmenumainli.onclick = function () {
                            let thiselem = mainmenumainli?.parentElement;
                            if (thiselem != null) {
                                if (thiselem.childNodes.length > 1) {
                                    let thiselemchildNodes = thiselem; //.children[1];
                                    if (thiselemchildNodes != null) {
                                        if (thiselemchildNodes.className.indexOf('experion_topmenu_vis') == -1) {
                                            thiselemchildNodes.className = 'experion_topmenu_vis';
                                            VisibelMenu = true;
                                        } else {
                                            VisibelMenu = false;

                                            let arrvis = document.getElementsByClassName('experion_topmenu_vis');

                                            for (let vis = 0; vis < arrvis.length; vis++) {
                                                arrvis[vis].classList.remove('experion_topmenu_vis');
                                            }
                                        }
                                    }
                                }
                            }
                        };
                    }
                    menumainli.onmouseover = function () {
                        if (VisibelMenu) {
                            let arrvis = document.getElementsByClassName('experion_topmenu_vis');
                            for (let vis = 0; vis < arrvis.length; vis++) {
                                arrvis[vis].classList.remove('experion_topmenu_vis');
                            }

                            (this as HTMLInputElement).className = 'experion_topmenu_vis';
                        }
                    };

                    menumainul.appendChild(menumainli);
                }
            }

            let experion_menupanelelem = document.getElementsByClassName('experion_menupanel')[0];
            if (experion_menupanelelem != null) {
                experion_menupanelelem.appendChild(menumaindiv);
            }
        }
    };

    let ConverChilds = function (childs: any): string {
        let Txt, ElementChilds, Element;
        let TempStr;
        let One = true;

        let NumberElementMenu = 0;

        let MaxLength = 1;
        Txt = '<ul>';

        for (NumberElementMenu = 0; NumberElementMenu < childs.length; NumberElementMenu++) {
            Element = childs[NumberElementMenu];
            if (Element.nodeName === 'Item') {
                TempStr = Element.getAttribute('CommandID');
                Txt = Txt + '<li>' + ExperionScript.FindCommand(TempStr, false);

                Txt = Txt + ExperionScript.FindImage(TempStr, true);
                Txt = Txt + Element.getAttribute('Caption');
                Txt = Txt + '</a></li>';
            }
            if (Element.nodeName === 'Separator') {
                // One = true;
                Txt = Txt + '<li><hr></li>';
            }
            if (Element.nodeName === 'Menu') {
                Txt = Txt + '<li class="fly">';

                Txt = Txt + '<a>';
                Txt = Txt + ExperionScript.FindImage(TempStr, true);
                Txt = Txt + Element.getAttribute('Caption');

                Txt = Txt + '</a>';

                ElementChilds = Element.childNodes;
                Txt = Txt + ConverChilds(ElementChilds);

                Txt = Txt + '</li>';
            }
        }
        Txt = Txt + '</ul>';
        return Txt;
    };

    let ofloadmenu = function () {
        window.removeEventListener('click', modifyMenu);
        window.removeEventListener('blur', blurwindow);
        document.getElementsByClassName('experion_menupanel')[0].innerHTML = '';
        document.getElementsByClassName('experion_topmenu_toolbar')[0].innerHTML = '';
        document.getElementsByClassName('experion_topmenu_line_three')[0].innerHTML = '';
    };

    if (refmenu) return <Navigate to={refmenu} />;

    return (
        <header className="experion_topmenu">
            <div className="experion_topmenu_line_one">
                <div className="experion_menupanel"></div>
            </div>

            <div className="experion_topmenu_line_two">
                <div className="experion_topmenu_toolbar"></div>
            </div>

            <div className="experion_topmenu_line_three"></div>
        </header>
    );
};

export default TopMenu;
